import { combineReducers } from 'redux';
import login from 'src/store/ducks/login';

export default combineReducers({
    login
});
